export default {
  main: {
    root: '/',
    title: 'Index page',
  },
};
